module.exports = __webpack_public_path__ + "img/charging-hub-definitive.6cd510b3.svg";